<template>
  <div
    class="content reset-body content-login-block w-100 h-100 d-flex justify-content-center align-items-center flex-column position-relative"
  >
    <div class="logo-top">
      <router-link to="/">
        <img :src="logo" class="logo-top my-5" />
      </router-link>
    </div>
    <div class="row content-body login-body align-items-center">
      <div class="col-lg-12 my-4">
        <div class="row">
          <div class="col-lg-12 my-4">
            <div class="d-grid text-center">
              <p class="title mb-3">{{ $t("user_reset_password.title") }}</p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-10 my-2">
            <div class="mx-auto form-register d-flex flex-column">
              <input
                type="password"
                v-model="newPassword"
                class="input-text"
                :class="{
                  'mb-2': errorPassword != '',
                  'mb-4': errorPassword == '',
                  error: errorPassword
                }"
                :placeholder="$t('user_reset_password.placeholders.new_password')"
              />
              <span v-if="errorPassword" class="error-message mb-4">{{ errorPassword }}</span>
              <input
                type="password"
                v-model="confirmNewPassword"
                class="input-text"
                :class="{
                  'mb-2': errorConfirmPassword != '',
                  'mb-4': errorConfirmPassword == '',
                  error: errorConfirmPassword
                }"
                :placeholder="$t('user_reset_password.placeholders.confirm_password')"
              />
              <span v-if="errorConfirmPassword" class="error-message mb-4">{{ errorConfirmPassword }}</span>
              <button
                class="btn text-white btn-register w-100 mb-4"
                id="reset"
                @click.prevent="handleResetPassword"
                :disabled="isLoading"
              >
                {{ $t("user_reset_password.buttons.change_password") }}
              </button>
              <span v-if="errorMessage" class="error-message mb-4">{{ errorMessage }}</span>
              <div v-if="infoMessage" class="alert alert-success mb-4">
                <span class="info-message">{{ infoMessage }}</span>
              </div>
            </div>
            <router-link to="/">
              <label class="prev-step">
                <img :src="prev" />
                {{ $t("user_reset_password.links.previous_step") }}
              </label>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ResetPassword } from "@/api/auth";
  import logo from "@/assets/images/2_LOGO - COULEURS-bg-b.png";
  import prev from "@/assets/images/icon-prev.svg";
  import $ from "jquery";

  export default {
    name: "ResetPassword",
    data() {
      return {
        logo,
        prev,
        newPassword: "",
        confirmNewPassword: "",
        errorPassword: "",
        errorConfirmPassword: "",
        errorMessage: "",
        isLoading: false,
        canReset: true,
        infoMessage: "",
      };
    },
    methods: {
      async handleResetPassword() {
        this.errorPassword = "";
        this.errorConfirmPassword = "";
        this.errorMessage = "";
        this.isLoading = true;
        this.canReset = true;
        var spinner =
          '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> ' +
          this.$t("user_reset_password.loading");

        $("#reset").html(spinner);
        this.CheckValidate();
        if (this.canReset) {
          var token = this.$route.query.token_verification;
          ResetPassword(token, this.newPassword, this.confirmNewPassword)
            .then(() => {
              $("#reset").text(this.$t("user_reset_password.buttons.change_password"));
              this.isLoading = false;
              this.infoMessage = this.$t("user_reset_password.messages.password_changed_success");
              setTimeout(() => {
                this.infoMessage = "";
              }, 5000);
            })
            .catch(res => {
              this.isLoading = false;
              this.errorMessage = res.response.data.message;
              $("#reset").text(this.$t("user_reset_password.buttons.change_password"));
            });
        }
      },
      CheckValidate() {
        if (typeof this.$route.query.token_verification == "undefined") {
          this.errorMessage = this.$t("user_reset_password.errors.token_not_found");
          this.canReset = false;
        }

        if (this.newPassword == "") {
          this.errorPassword = this.$t("user_reset_password.errors.password_required");
          this.canReset = false;
        }

        if (this.confirmNewPassword == "") {
          this.errorConfirmPassword = this.$t("user_reset_password.errors.confirm_password_required");
          this.canReset = false;
        }

        if (this.newPassword != "" && this.confirmNewPassword != "" && this.newPassword != this.confirmNewPassword) {
          this.errorConfirmPassword = this.$t("user_reset_password.errors.passwords_do_not_match");
          this.canReset = false;
        }

        if (!this.canReset) {
          this.isLoading = false;
          $("#reset").text(this.$t("user_reset_password.buttons.change_password"));
        }
      },
    },
  };
</script>

<style scoped>
  .reset-body {
    position: relative;
    height: 100%;
  }
  .logo-top img {
    margin-right: 20px;
  }

  .reset-body .title {
    color: #1e347d;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 29px;
  }
  .form-register {
    input {
      height: 40px;
      background: #ffffff 0% 0% no-repeat padding-box;
      border: 2px solid #aeb1ba;
      border-radius: 76px;
      padding: 0 20px;
      transition: all 0.3s ease-in-out;
    }
    input:focus {
      border-color: #c9cfde;
      box-shadow: 0 0 8px #c9cfde;
      transform: scale(1.05);
      outline: none;
    }
  }
  .btn-register {
    background-color: #ec621a !important;
    border-radius: 76px;
    font-size: 19px;
    text-align: center;
    font: normal normal bold 19px/25px DM Sans;
    letter-spacing: 0px;
  }
  .prev-step {
    font-size: 15px;
    color: #1e347d;
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: bold;
    cursor: pointer;
  }
  .error {
    border-color: red !important;
  }
  .alert {
    border-radius: 4px;
    color: #515a6e;
    font-size: 18px;
    line-height: 16px;
    margin-bottom: 10px;
    position: relative;
  }
  .alert-success {
    background-color: #edfff3;
    border: 1px solid #8ce6b0;
  }
  .error-message {
    color: red;
    margin-left: 8px;
  }
  .info-message {
    margin-left: 8px;
  }
</style>